import styled from "styled-components";

export const MainText = styled.span`
  font-family: "BOLD";
  color: ${({ color }) => (color ? color : "black")};
`;

export const MainRegularText = styled.span`
  font-family: "REGULAR";
  color: ${({ color }) => (color ? color : "black")};
`;

export const TextSS = styled(MainText)`
  font-size: 13px;
  @media ${({ theme }) => theme.device.tablet} {
    font-size: 18px;
  }
  @media ${({ theme }) => theme.device.laptop} {
    font-size: 18px;
  }
  line-height: 1.2;
`;

export const TextS = styled(MainText)`
  font-size: 14px;
  @media ${({ theme }) => theme.device.tablet} {
    font-size: 20px;
  }
  @media ${({ theme }) => theme.device.laptop} {
    font-size: 20px;
  }
  line-height: 1.2;
`;

export const TextMS = styled(MainText)`
  font-size: 15px;
  @media ${({ theme }) => theme.device.tablet} {
    font-size: 22px;
  }
  @media ${({ theme }) => theme.device.laptop} {
    font-size: 22px;
  }
  line-height: 1.2;
`;

export const TextM = styled(MainText)`
  font-size: 18px;
  @media ${({ theme }) => theme.device.tablet} {
    font-size: 25px;
  }
  @media ${({ theme }) => theme.device.laptop} {
    font-size: 25px;
  }

  line-height: 1.3;
`;

export const TextL = styled(MainText)`
  font-size: 19px;
  @media ${({ theme }) => theme.device.tablet} {
    font-size: 29px;
  }
  @media ${({ theme }) => theme.device.laptop} {
    font-size: 26px;
  }
  font-weight: 600;
  line-height: 1.5;
`;
export const TextXL = styled(MainText)`
  font-weight: 900;
  font-size: 20px;
  @media ${({ theme }) => theme.device.tablet} {
    font-size: 30px;
  }
  @media ${({ theme }) => theme.device.laptop} {
    font-size: 30px;
  }
`;

export const TextRS = styled(MainRegularText)`
  font-size: 14px;
  @media ${({ theme }) => theme.device.tablet} {
    font-size: 20px;
  }
  @media ${({ theme }) => theme.device.laptop} {
    font-size: 20px;
  }
  line-height: 1.2;
`;

export const TextRXS = styled(MainRegularText)`
  font-size: 11px;
  @media ${({ theme }) => theme.device.tablet} {
    font-size: 13px;
  }
  @media ${({ theme }) => theme.device.laptop} {
    font-size: 13px;
  }
  line-height: 1.2;
`;
